// Importe de un artículo de pedido. Misma fórmula que usa el checkout al cobrar.
export const calcularMontoArticulo = (p) => {
  const cant = p.cantidad || 1;
  const dur = p.cantidadDuracion || 1;
  if (p.tipo === "producto") return p.total * cant;
  if (p.stock) return p.total * (p.duracion === "unico" ? 1 : cant * dur);
  return p.total * (p.duracion === "unico" ? 1 : dur);
};

// El inventario de los artículos devueltos lo regresa la función de servidor restaurarStockEnDevolucion.
